import {
  faArrowRightFromBracket,
  faChevronLeft,
  faChartSimple
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonImg,
  IonLabel,
  IonList,
  IonMenuButton,
  IonPage,
  IonProgressBar,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import "./results.scss";
import { useEffect, useState } from "react";
import Glide from "@glidejs/glide";
import coffeeTools from "../../CoffeeTools";
import lnbp_logo from "./../../icon/icon.png";

const Results: React.FC = () => {
  const [showProgessBar, setShowProgessBar] = useState(true);
  let base_url = process.env.REACT_APP_BASE_URL;
  let id_season = process.env.REACT_APP_ID_SEASON;
  let coffee_tools = new coffeeTools();
  const urlParams = new URLSearchParams(window.location.search);
  //declared outside to make it global and used it on the page

  const [filterRounds, setFilterRounds] = useState([]);
  const [filterSeason, setFilterSeason] = useState([]);
  const [idSelectedRound, setIdSelectedRound] = useState("");
  const [idSelectedSeason, setIdSelectedSeason] = useState("");
  useEffect(() => {
    // show slider
    //start the page
    let coffee = new coffeeTools();
    mainController.init();
  }, []);

  var controller = (() => {
    function getSeasons(callback) {
      fetch(base_url + "/sports/seasons/all", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }

    function getRounds(callback, id_season) {
      fetch(base_url + "/sports/rounds/season", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_season: id_season
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }

    function getScores(callback, id_round) {
      fetch(base_url + "/sports/games/filtered", {
        method: "Post",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id_round: id_round,
          played: true,
          with: ["team_1", "team_2", "round"]
        })
      })
        .then((response) => response.json())
        .then((response) => {
          callback(response);
        });
    }

    return {
      getRounds: (callback, id_season) => getRounds(callback, id_season),
      getSeasons: (callback) => getSeasons(callback),
      getScores: (callback, id_round) => getScores(callback, id_round)
    };
  })();

  let view = (() => {
    let dom_obj = {
      scores_table_container: "js__results_table_container"
    };

    // used in the rounds filter
    function showRounds(response) {
      let select_rounds = [];
      if (response.items.length > 0) {
        response.items.forEach(function (item) {
          select_rounds.push(
            <IonSelectOption
              key={item.id}
              value={item.id}
            >
              {item.name}
            </IonSelectOption>
          );
        });
        setFilterRounds(select_rounds);
      }
    }

    // used in the season filter
    function showSeason(response) {
      let select_season = [];
      if (response.items.length > 0) {
        response.items.forEach(function (item) {
          select_season.push(
            <IonSelectOption
              key={item.id}
              value={item.id}
            >
              {item.name}
            </IonSelectOption>
          );
        });
        setFilterSeason(select_season);
      }
    }

    // used to show the table
    function showScores(response) {
      var scores_list_table = document.createElement("table");
      scores_list_table.classList.add("score-table");
      // console.log("this is showScores", response);
      console.log("this is showScores", response.items.length);
      if (response.items.length > 0) {
        // console.log("this is showScores", response);
        response.items.forEach(function (item) {
          let table_row = document.createElement("tr");
          table_row.style.position = "relative";
          let table_team_1_logo = document.createElement("td");

          let team_1_logo = document.createElement("img");
          team_1_logo.src = base_url + item.team_1.full_url_logo;
          team_1_logo.style.backgroundColor = item.team_1.team_color;

          team_1_logo.classList.add("score_table_img");
          table_team_1_logo.appendChild(team_1_logo);

          // let table_team_1 = document.createElement("td");
          // table_team_1.innerHTML = item.participant_a;

          let table_team_1_score = document.createElement("td");
          table_team_1_score.innerHTML = item.score_1;
          table_team_1_score.style.color = "black";

          let table_vs = document.createElement("td");
          table_vs.style.color = "black";
          table_vs.innerHTML = "VS";

          // add date and season as absolute position
          let date = document.createElement("span");
          let season = document.createElement("span");
          date.classList.add("score-table-date");
          date.style.color = "black";
          season.classList.add("score-table-season");
          date.innerHTML = item.event.date_start;
          season.innerHTML = item.round.name;
          season.style.position = "absolute";
          season.style.width = "100%";
          season.style.left = "0";
          table_vs.appendChild(date);
          table_vs.appendChild(season);

          // let table_team_2 = document.createElement("td");
          // table_team_2.innerHTML = item.participant_b;

          let table_team_2_score = document.createElement("td");
          table_team_2_score.innerHTML = item.score_2;
          table_team_2_score.style.color = "black";

          let table_team_2_logo = document.createElement("td");
          let team_2_logo = document.createElement("img");
          team_2_logo.src = base_url + item.team_2.full_url_logo;
          team_2_logo.style.backgroundColor = item.team_2.team_color;
          team_2_logo.classList.add("score_table_img");
          table_team_2_logo.appendChild(team_2_logo);

          table_row.appendChild(table_team_1_logo);
          // table_row.appendChild(table_team_1);
          table_row.appendChild(table_team_1_score);
          table_row.appendChild(table_vs);
          // table_row.appendChild(table_team_2);
          table_row.appendChild(table_team_2_score);
          table_row.appendChild(table_team_2_logo);

          //create row for video
          let table_row_video = document.createElement("tr");
          table_row_video.style.display = "none";
          let table_row_video_td = document.createElement("td");

          table_row_video.appendChild(table_row_video_td);

          scores_list_table.appendChild(table_row);
        });
      } else {
        console.log("here");
        document.getElementById(dom_obj.scores_table_container).innerHTML = "";
        scores_list_table.innerHTML = "No hay resultados";
      }

      document.getElementById(dom_obj.scores_table_container).innerHTML = "";
      document
        .getElementById(dom_obj.scores_table_container)
        .appendChild(scores_list_table);
    }
    return {
      showRounds: (response) => showRounds(response),
      showSeason: (response) => showSeason(response),
      showScores: (response) => showScores(response),
      dom_obj: dom_obj
    };
  })();

  var mainController = (function (page_controller, page_view) {
    var setupEventListeners = function () {};
    return {
      init: function () {
        console.log("Menu started");
        setupEventListeners();
        // hide progress bar
        setShowProgessBar(false);

        //get seasons
        page_controller.getSeasons(page_view.showSeason);

        //get rounds
        // page_controller.getRounds(page_view.showRounds, id_season);
      }
    };
  })(controller, view);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          className='home_toolbar'
          color={"secondary"}
        >
          <div hidden={!showProgessBar}>
            <IonProgressBar type='indeterminate'></IonProgressBar>
          </div>
          <IonButtons slot='start'>
            <IonMenuButton></IonMenuButton>
            <IonButton
              onClick={() => {
                window.history.back();
              }}
            >
              <FontAwesomeIcon
                size='lg'
                pull='left'
                icon={faChevronLeft}
              />
            </IonButton>
          </IonButtons>
          <div className='header_lnbp_icon'>
            <img
              src={lnbp_logo}
              alt='LNBP'
            />
          </div>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div id='js__filters'>
          <IonList className='scores-list'>
            <IonItem className='scores-select'>
              <IonSelect
                placeholder='Temporada'
                onIonChange={(e) => {
                  setIdSelectedSeason(e.target.value);
                  setIdSelectedRound("");

                  if (e.target.value != "" && e.target.value != undefined) {
                    controller.getRounds(view.showRounds, e.target.value);
                  } else {
                    document.getElementById(
                      view.dom_obj.scores_table_container
                    ).innerHTML = "Seleccionar una temporada y una jornada";
                  }
                }}
              >
                {filterSeason.map((item) => {
                  return item;
                })}
              </IonSelect>
            </IonItem>
            <IonItem className='scores-select'>
              <IonSelect
                placeholder='Jornada'
                onIonChange={(e) => {
                  setIdSelectedRound(e.target.value);
                  if (e.target.value == "" && e.target.value == undefined) {
                    document.getElementById(
                      view.dom_obj.scores_table_container
                    ).innerHTML = "Seleccionar una temporada y una jornada";
                  }
                }}
              >
                {filterRounds.map((item) => {
                  return item;
                })}
              </IonSelect>
            </IonItem>
          </IonList>
          <IonButton
            style={{
              width: "100%",
              height: "100%",
              padding: "0 1rem"
            }}
            onClick={() => {
              if (idSelectedSeason == "" || idSelectedSeason == undefined) {
                document.getElementById(
                  "js__results_table_container"
                ).innerHTML = "Seleccionar una temporada";
                return;
              }

              if (idSelectedRound == "" || idSelectedRound == undefined) {
                document.getElementById(
                  "js__results_table_container"
                ).innerHTML = "Seleccionar una jornada";
                return;
              }

              controller.getScores(view.showScores, idSelectedRound);
            }}
          >
            Filtrar
          </IonButton>
          <hr />
          <div
            id='js__results_table_container'
            className='ion-text-center'
          >
            Seleccionar una temporada y una jornada
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Results;
